import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import styles from './styles';
import TickSvg from './TickSvg';

const ClientDetailsRow = ({label1, value1, label2}) => {
  return (
    <View style={styles.row}>
      <View style={[styles.flex1, styles.contentSection]}>
        <Text style={[styles.text, styles.bold]}>{label1}:</Text>
      </View>
      <View style={[styles.flex2, styles.contentSection, styles.borderLeft]}>
        <Text style={styles.text}>{value1}</Text>
      </View>
      <View style={[styles.flex1, styles.contentSection, styles.borderLeft]}>
        <Text style={[styles.text, styles.bold]}>{label2}:</Text>
      </View>
    </View>
  );
};

const TypeCheck = ({text, checked}) => (
  <View style={[styles.flex1, styles.borderLeft]}>
    <View style={[styles.flex1, styles.contentSection, styles.center]}>
      <View style={[styles.checkContent, styles.center]}>
        {checked && <TickSvg />}
      </View>
    </View>
    <View style={[styles.contentSection, styles.center]}>
      <Text style={[styles.text, styles.bold]}>{text}</Text>
    </View>
  </View>
);

const ClientDetailsInfo = ({
  ordinalNr,
  client,
  elevator,
  address,
  elevatorId,
  project,
  period,
  type,
}) => {
  return (
    <View style={styles.table}>
      <View style={styles.row}>
        <View style={[styles.sectionHeader, styles.width60, styles.noBorder]}>
          <Text style={[styles.text, styles.center, styles.bold]}>
            TË DHËNAT E KLIENTIT
          </Text>
        </View>
        <View style={[styles.sectionHeader, styles.nrRendor, styles.noBorder]}>
          <Text style={styles.text}>Nr. rendor: {ordinalNr}</Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.width60}>
          <ClientDetailsRow
            label1="Klienti"
            value1={client}
            label2="Numri serik"
          />
          <ClientDetailsRow
            label1="Emri i ashensorit"
            value1={elevator}
            label2="Projekti"
          />
          <ClientDetailsRow
            label1="Adresa"
            value1={address}
            label2="Periudha"
          />
        </View>
        <View style={[styles.row, styles.flex1, styles.borderLeft]}>
          <View style={styles.flex3}>
            <View style={styles.contentSection}>
              <Text style={styles.text}>{elevatorId} </Text>
            </View>
            <View style={styles.contentSection}>
              <Text style={styles.text}>{project} </Text>
            </View>
            <View style={styles.contentSection}>
              <Text style={styles.text}>{period} </Text>
            </View>
          </View>
          <TypeCheck text="Servisim" checked={type === 'service'} />
          <TypeCheck text="Kontroll" checked={type === 'control'} />
        </View>
      </View>
    </View>
  );
};

export default ClientDetailsInfo;
